import { gql } from "@apollo/client";
import { AtsStageForEditorFragment } from "generated/schemaTypes";

export const ATS_STAGE_FOR_EDITOR_FRAGMENT = gql`
  fragment AtsStageForEditorFragment on ATSJobRoleStage {
    id
    name
    position
  }
`;

type AtsStage = AtsStageForEditorFragment;

export default AtsStage;
